import { NotificationsGroup } from 'components/Notifications/types';
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  PREVIOUS_SIGNUP_STEP,
  SET_SIGNUP_STEP,
  SUBMIT_SIGNUP_STEP,
  SET_USER_INFO,
  SET_TOKEN,
  SET_EMAIL,
  SUBMIT_SIGNUP_STEP_SUCCESS,
  SUBMIT_SIGNUP_STEP_FAIL,
  SET_PIN_ID,
  SET_IS_USER_FOUND,
  SET_LOGIN,
  SET_ROLES,
  SET_NOTIFICATIONS,
  GET_NOTIFICATIONS,
  SET_NOTIFICATION_READ,
  SET_NOTIFICATION_READ_SUCCESS,
  SET_NOTIFICATION_READ_FAILURE,
  GET_PROFILE_SETTINGS_INFO,
  SET_PROFILE_SETTINGS_INFO,
  UPDATE_PROFILE_SETTINGS_INFO,
  UPDATE_PROFILE_SETTINGS_INFO_FAIL,
  UPDATE_PROFILE_SETTINGS_INFO_SUCCESS,
  GET_USER_INFO,
  GET_USER_INFO_SUCCESS,
  GET_USER_INFO_FAIL,
  SET_IDENTITY_IMAGES,
  RESEND_EMAIL,
} from 'store/user/constants';

import {
  ActionWithPayloadType,
  UserPayloadType,
  ErrorPayloadType,
  ActionWithoutPayloadType,
  UserSelectorType,
  RequestLoginPayloadType,
} from 'store/user/types';

const resendEmail = (): resendEmailType => ({
  type: RESEND_EMAIL,
  payload: null,
});

const requestLogin = (payload: RequestLoginPayloadType): RequestLoginType => ({
  type: LOGIN_REQUEST,
  payload: payload,
});

const setSignupStep = (payload: string): setSignupStepType => ({
  type: SET_SIGNUP_STEP,
  payload: payload,
});

const submitSignupStep = (payload: any): SubmitSignupStepType => ({
  type: SUBMIT_SIGNUP_STEP,
  payload: payload,
});

const submitSignupStepSuccess = (
  payload: any,
): SubmitSignupStepSuccessType => ({
  type: SUBMIT_SIGNUP_STEP_SUCCESS,
  payload: payload,
});

const submitSignupStepFail = (payload: any): SubmitSignupStepFailType => ({
  type: SUBMIT_SIGNUP_STEP_FAIL,
  payload: payload,
});

const loginSuccesss = (user: UserPayloadType): LoginSuccessType => ({
  type: LOGIN_SUCCESS,
  payload: user,
});

const loginFail = (error: ErrorPayloadType): LoginFailType => ({
  type: LOGIN_FAIL,
  payload: error,
});

const previousSignupStep = (): PreviousSignupStepType => ({
  type: PREVIOUS_SIGNUP_STEP,
});

const setUserInfo = (user: UserSelectorType): SetUserInfoType => ({
  type: SET_USER_INFO,
  payload: user,
});

const setToken = (token: string): SetTokenType => ({
  type: SET_TOKEN,
  payload: token,
});
const setEmail = (email: string): SetEmailType => ({
  type: SET_EMAIL,
  payload: email,
});

const setPinId = (pinId: string): SetPinIdType => ({
  type: SET_PIN_ID,
  payload: pinId,
});

const setIsUserFound = (): SetIsUserFoundType => ({
  type: SET_IS_USER_FOUND,
});

const setLogin = (login: string): SetLoginType => ({
  type: SET_LOGIN,
  payload: login,
});
const SetRoles = (roles: any): SetRolesTypes => ({
  type: SET_ROLES,
  payload: roles,
});
const setNotifications = (Notifications: any): SetNotificationsTypes => ({
  type: SET_NOTIFICATIONS,
  payload: Notifications,
});
export const getNotifications = (): GetNotificationsTypes => ({
  type: GET_NOTIFICATIONS,
  payload: null,
});
export const setNotificationRead = (
  notificationReadPayload: NotificationReadPayload,
): SetNotificationReadTypes => ({
  type: SET_NOTIFICATION_READ,
  payload: notificationReadPayload,
});
export const setNotificationReadFailure = (): SetNotificationReadFailureTypes => ({
  type: SET_NOTIFICATION_READ_FAILURE,
  payload: null,
});
export const setNotificationReadSucces = (
  payload: NotificationReadPayload,
): SetNotificationReadSuccessTypes => ({
  type: SET_NOTIFICATION_READ_SUCCESS,
  payload: payload,
});

const getProfileSettingsInfo = (): GetProfileSettingsInfoType => ({
  type: GET_PROFILE_SETTINGS_INFO,
});

const setProfileSettingsInfo = (payload: any): SetProfileSettingsInfoType => ({
  type: SET_PROFILE_SETTINGS_INFO,
  payload,
});

const updateProfileSettingsInfo = (
  payload: any,
): UpdateSettingsProfileInfoType => ({
  type: UPDATE_PROFILE_SETTINGS_INFO,
  payload,
});

const updateProfileSettingsInfoSuccess = (): UpdateSettingsProfileInfoSuccessType => ({
  type: UPDATE_PROFILE_SETTINGS_INFO_SUCCESS,
});

const updateProfileSettingsInfoFail = (): UpdateSettingsProfileInfoFailType => ({
  type: UPDATE_PROFILE_SETTINGS_INFO_FAIL,
});

const getUserInfo = (): GetUserInfoType => ({
  type: GET_USER_INFO,
});

const getUserInfoSuccess = (payload: any): GetUserInfoSuccessType => ({
  type: GET_USER_INFO_SUCCESS,
  payload,
});

const getUserInfoFail = (): GetUserInfoFailType => ({
  type: GET_USER_INFO_FAIL,
});

const setIdentityImages = (payload: string): SetIdentityImages => ({
  type: SET_IDENTITY_IMAGES,
  payload,
});

export {
  requestLogin,
  setSignupStep,
  submitSignupStep,
  submitSignupStepSuccess,
  submitSignupStepFail,
  loginSuccesss,
  loginFail,
  previousSignupStep,
  setUserInfo,
  setToken,
  setEmail,
  setPinId,
  setIsUserFound,
  setLogin,
  SetRoles,
  setNotifications,
  getProfileSettingsInfo,
  setProfileSettingsInfo,
  updateProfileSettingsInfo,
  updateProfileSettingsInfoSuccess,
  updateProfileSettingsInfoFail,
  getUserInfo,
  getUserInfoSuccess,
  getUserInfoFail,
  setIdentityImages,
  resendEmail,
};

export type UserActionType =
  | RequestLoginType
  | LoginSuccessType
  | LoginFailType
  | PreviousSignupStepType
  | setSignupStepType
  | SubmitSignupStepType
  | SetUserInfoType
  | SetTokenType
  | SetEmailType
  | SubmitSignupStepSuccessType
  | SubmitSignupStepFailType
  | SetPinIdType
  | SetIsUserFoundType
  | SetRolesTypes
  | SetNotificationsTypes
  | GetNotificationsTypes
  | SetNotificationReadTypes
  | SetNotificationReadSuccessTypes
  | SetNotificationReadFailureTypes
  | SetLoginType
  | GetProfileSettingsInfoType
  | SetProfileSettingsInfoType
  | UpdateSettingsProfileInfoType
  | UpdateSettingsProfileInfoSuccessType
  | UpdateSettingsProfileInfoFailType
  | GetUserInfoType
  | GetUserInfoSuccessType
  | GetUserInfoFailType
  | resendEmailType
  | SetIdentityImages;

type RequestLoginType = ActionWithPayloadType<
  typeof LOGIN_REQUEST,
  RequestLoginPayloadType
>;
type LoginSuccessType = ActionWithPayloadType<
  typeof LOGIN_SUCCESS,
  UserPayloadType
>;
type LoginFailType = ActionWithPayloadType<typeof LOGIN_FAIL, ErrorPayloadType>;

type PreviousSignupStepType = ActionWithoutPayloadType<
  typeof PREVIOUS_SIGNUP_STEP
>;

type SubmitSignupStepType = ActionWithPayloadType<
  typeof SUBMIT_SIGNUP_STEP,
  any
>;
type resendEmailType = ActionWithPayloadType<typeof RESEND_EMAIL, null>;

type SubmitSignupStepSuccessType = ActionWithPayloadType<
  typeof SUBMIT_SIGNUP_STEP_SUCCESS,
  any
>;

type SubmitSignupStepFailType = ActionWithPayloadType<
  typeof SUBMIT_SIGNUP_STEP_FAIL,
  any
>;

type setSignupStepType = ActionWithPayloadType<typeof SET_SIGNUP_STEP, string>;

type SetUserInfoType = ActionWithPayloadType<
  typeof SET_USER_INFO,
  UserSelectorType
>;

type SetTokenType = ActionWithPayloadType<typeof SET_TOKEN, string>;
type SetEmailType = ActionWithPayloadType<typeof SET_EMAIL, string>;

type SetPinIdType = ActionWithPayloadType<typeof SET_PIN_ID, string>;

type SetIsUserFoundType = ActionWithoutPayloadType<typeof SET_IS_USER_FOUND>;

type SetLoginType = ActionWithPayloadType<typeof SET_LOGIN, string>;

type SetRolesTypes = ActionWithPayloadType<typeof SET_ROLES, string>;
type SetNotificationsTypes = ActionWithPayloadType<
  typeof SET_NOTIFICATIONS,
  NotificationsGroup[]
>;
type GetNotificationsTypes = ActionWithPayloadType<
  typeof GET_NOTIFICATIONS,
  null
>;
type SetNotificationReadTypes = ActionWithPayloadType<
  typeof SET_NOTIFICATION_READ,
  NotificationReadPayload
>;
type SetNotificationReadSuccessTypes = ActionWithPayloadType<
  typeof SET_NOTIFICATION_READ_SUCCESS,
  NotificationReadPayload
>;
type SetNotificationReadFailureTypes = ActionWithPayloadType<
  typeof SET_NOTIFICATION_READ_FAILURE,
  null
>;

export type NotificationReadPayload = {
  id: number;
  group?: string;
};

type GetProfileSettingsInfoType = ActionWithoutPayloadType<
  typeof GET_PROFILE_SETTINGS_INFO
>;

type SetProfileSettingsInfoType = ActionWithPayloadType<
  typeof SET_PROFILE_SETTINGS_INFO,
  any
>;

type UpdateSettingsProfileInfoType = ActionWithPayloadType<
  typeof UPDATE_PROFILE_SETTINGS_INFO,
  any
>;
type UpdateSettingsProfileInfoSuccessType = ActionWithoutPayloadType<
  typeof UPDATE_PROFILE_SETTINGS_INFO_SUCCESS
>;
type UpdateSettingsProfileInfoFailType = ActionWithoutPayloadType<
  typeof UPDATE_PROFILE_SETTINGS_INFO_FAIL
>;

type GetUserInfoType = ActionWithoutPayloadType<typeof GET_USER_INFO>;
type GetUserInfoSuccessType = ActionWithPayloadType<
  typeof GET_USER_INFO_SUCCESS,
  any
>;
type GetUserInfoFailType = ActionWithoutPayloadType<typeof GET_USER_INFO_FAIL>;

type SetIdentityImages = ActionWithPayloadType<typeof SET_IDENTITY_IMAGES, any>;
